var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWhatsappIcon = function SvgWhatsappIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6325",
    "data-name": "Grupo 6325",
    transform: "translate(-559 -3349)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_287",
    "data-name": "Ret\\xE2ngulo 287",
    width: 24,
    height: 24,
    transform: "translate(559 3349)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_66",
    "data-name": "Grupo 66",
    transform: "translate(561.23 3351.182)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6322",
    "data-name": "Grupo 6322",
    transform: "translate(0 0.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2484",
    "data-name": "Caminho 2484",
    d: "M19.541,9.739a9.742,9.742,0,0,1-9.729,9.725h0a9.713,9.713,0,0,1-4.65-1.184L0,19.633l1.381-5.04A9.73,9.73,0,0,1,16.694,2.858a9.664,9.664,0,0,1,2.847,6.881",
    transform: "translate(0 -0.005)",
    fill: "#4b4b4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2485",
    "data-name": "Caminho 2485",
    d: "M328.256,350.422a2.452,2.452,0,0,1-1.642,1.155c-.445.041-.863.2-2.917-.608a9.974,9.974,0,0,1-4.152-3.669,4.73,4.73,0,0,1-.993-2.514,2.725,2.725,0,0,1,.851-2.028.9.9,0,0,1,.648-.3c.163,0,.324,0,.466.006.174.007.365.016.547.42.216.481.688,1.683.75,1.8a.447.447,0,0,1,.019.426,1.664,1.664,0,0,1-.243.405c-.121.142-.256.318-.364.426s-.249.254-.107.5a7.3,7.3,0,0,0,1.352,1.683,6.678,6.678,0,0,0,1.955,1.207c.244.121.386.1.527-.062s.608-.709.77-.953.324-.2.546-.121,1.418.669,1.661.791.405.182.467.283a2.033,2.033,0,0,1-.142,1.156",
    transform: "translate(-313.684 -337.221)",
    fill: "#fff"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWhatsappIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/whatsapp-icon.89db4937.svg";
export { ForwardRef as ReactComponent };